import { createContext, useContext } from 'react';

import { CompanyMetadata } from '__generated__/GQL';
import { FCWithChildren } from 'common/types';

interface CompanySettingsContext {
  metadata?: Pick<CompanyMetadata, 'maxInvoiceCardPayment'>;
}

const companySettingsContext = createContext<CompanySettingsContext | null>(
  null,
);

/**
 * This Provider is expected to be used in pair with the query hook
 * `useCompanySettingsQuery` in order to store its result.
 */
export const CompanySettingsProvider: FCWithChildren<
  CompanySettingsContext
> = ({ children, metadata }) => {
  return (
    <companySettingsContext.Provider value={{ metadata }}>
      {children}
    </companySettingsContext.Provider>
  );
};

export const useCompanySettings = () => {
  const contextValues = useContext(companySettingsContext);

  if (!contextValues) {
    throw new Error(
      '"useCompanySettings" can only be used under CompanySettingsProvider',
    );
  }

  return contextValues;
};
